module.exports = __webpack_public_path__ + "static/GlitchlessSonyax57-4d46a686a69718d124beb406c64ad6c7.png";